/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTemplateDto } from '../../models/ticket-template-dto';

export interface AdminTicketTypeControllerFindAllTypes$Params {
  centerId: string;
}

export function adminTicketTypeControllerFindAllTypes(http: HttpClient, rootUrl: string, params: AdminTicketTypeControllerFindAllTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketTemplateDto>>> {
  const rb = new RequestBuilder(rootUrl, adminTicketTypeControllerFindAllTypes.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TicketTemplateDto>>;
    })
  );
}

adminTicketTypeControllerFindAllTypes.PATH = '/api/ticket-type/admin/{centerId}';
